// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import slideshow from './js/widgets/slideshow.js';
import photoGallery from './js/widgets/photoGallery.js';
import cardWidget from './js/widgets/cardWidget.js';
import autoEvent from './js/widgets/autoEvent.js';
import seoWidget from './js/widgets/seoWidget.js';
import videoWidget from './js/widgets/videoWidget.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketButton();
  if (globalThis.location.pathname === '/') {
    slideshow();
    cardWidget('cardWidgetFirst', cardWidgetFirstOpts, 2);
    cardWidget('cardWidgetSecond', cardWidgetSecondOpts, 4);
    autoEvent();
    seoWidget();
    videoWidget();
    photoGallery();
  }
});
